<template>
  <div>
    <LmListV2
      ref="lmlistv2"
      v-if="isAllowed"
      :listEndpointUri=listEndpointUri
    />
    <div v-if="isAllowed" class="wrapper-content w-100" id="licencias-por-usuario-new-or-edit">
      <hr>
      <h2>{{title}}</h2>
      <h4>{{subTitle}}</h4>
      <div>
        <LmBreadcrumb v-if="showBreadcrumb" />
        <LmForm ref="lmFormRef">
          <LmComponentLoading v-if="isLoading"/>
          <div class="row">
            <LmDateTime
              class="col-12 col-lg-4"
              v-model="form.fechaDesde"
              :v="$v.form.fechaDesde"
              label="Fecha Desde"
              id="fechaDesde"
              :config="lmDateTimeConfig"
              placeholder="Fecha Desde"
              />
            <LmDateTime
              class="col-12 col-lg-4"
              v-model="form.fechaHasta"
              :v="$v.form.fechaHasta"
              label="Fecha Hasta"
              id="fechaHasta"
              :config="lmDateTimeConfigHasta"
              placeholder="Fecha Hasta"
              :disabled="!form.fechaDesde"
              />
            <LmSuperPowerSelect
              ref="superpowerReemplazante"
              class="col-12 col-lg-4"
              :data="lmSuperPowerSelects.usuarios.selectOptions"
              :tbColumns="lmSuperPowerSelects.usuarios.tbColumns"
              label="Reemplazante"
              title="Reemplazante"
              placeholder="Seleccione"
              @values="actualizarUsuarioAsignado"
              :v="$v.form.reemplazante"
            />
          </div>
          <LmButton
            id="go-back-button"
            v-if="enableGoBackButton"
            type="button"
            buttonClass="btn-secondary"
            :value="$t('go_back')"
            @click.native="goBackBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            />
          <LmButton
            id="cancel-button"
            v-if="!enableGoBackButton"
            type="button"
            buttonClass="btn-secondary"
            :isProcessing="formIsProcessing"
            :value="$t('Cancel')"
            @click.native="cancelBtn"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            />
          <LmButton
            id="btn-submit"
            type="submit"
            buttonClass="btn-primary"
            :isProcessing="formIsProcessing"
            :value="$t('Save')"
            lmButtonRootWrapperClass="d-inline-block mr-1"
            lmButtonWrapperClass="col"
            @click.native="save(false)"
            :disabled="$v.form.$invalid"
          />
        </LmForm>
      </div>
      <lmConfirmationModal ref="lmConfirmationDeleteModal" title="Aviso" message="Esta por eliminar la licencia.  Está seguro?"/>
    </div>
    <div v-else class="wrapper-content w-100">
      <LmError
        title="Lo sentimos"
        :subtitle="'No puede asignarle permisos al usuario ' + $route.params.id"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import LmForm from '@/components/form/LmForm.vue'
import LmButton from '@/components/form/elements/LmButton'
import lmToasts from '@/mixins/lmToasts.js'
import lmConfirmationModal from '@/components/modals/LmConfirmationModal'
import LmListV2 from '@/components/LmListV2'
import LmDateTime from '@/components/form/elements/LmDateTime'
import { Spanish } from 'flatpickr/dist/l10n/es.js'
import LmSuperPowerSelect from '@/components/form/elements/LmSuperPowerSelect.vue'
import lmSuperPowerSelectHelper from '@/mixins/LmSuperPowerSelectHelper.js'
import LmError from '@/components/LmError'

export default {
  mixins: [lmSuperPowerSelectHelper, lmToasts],
  components: {
    LmForm,
    LmButton,
    lmConfirmationModal,
    LmListV2,
    LmDateTime,
    LmSuperPowerSelect,
    LmError
  },
  data () {
    return {
      showBreadcrumb: process.env.VUE_APP_SHOWBREADCRUMB === 'yes',
      isLoading: true,
      isAllowed: true,
      lmSuperPowerSelects: {
        usuarios: {
          selectOptions: [],
          tbColumns: [
            { title: 'id', data: 'id' },
            { title: 'Usuario', data: 'name' }
          ]
        }
      },
      form: {
        fechaDesde: null,
        fechaHasta: null,
        reemplazante: null
      },
      listEndpointUri: `licencias/porusuario/${this.$route.params.id}`,
      initialForm: {},
      formIsProcessing: false,
      lmDateTimeConfig: {
        dateFormat: 'Y-m-d H:i',
        locale: Spanish,
        allowInput: true,
        enableTime: true
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    newEndpointUri: {
      type: String,
      required: true
    },
    enableGoBackButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  validations () {
    return {
      form: {
        fechaDesde: {
          required
        },
        fechaHasta: {
          required
        },
        reemplazante: {
          required
        }
      }
    }
  },
  computed: {
    lmDateTimeConfigHasta: function () {
      return {
        ...this.lmDateTimeConfig,
        minDate: moment(new Date(this.form.fechaDesde)).add(1, 'hours').format('YYYY-MM-DD HH:mm:ss') || new Date()
      }
    }
  },
  methods: {
    ...mapActions('commons', ['updateItemDetail']),
    ...mapActions('settings', ['geAddOrEditSettings']),
    goBackBtn () {
      this.$router.go(-1)
    },
    cancelBtn () {
      this.$router.go(-1)
    },
    async save () {
      try {
        this.formIsProcessing = true
        await this.$refs.lmFormRef.validationForm(this.$v)
        const insertAttributes = {
          id: this.$route.params.id,
          start_time: this.form.fechaDesde,
          end_time: this.form.fechaHasta,
          reemplazante: this.form.reemplazante
        }
        this.updateItemDetail({
          path: this.newEndpointUri,
          data: insertAttributes
        })
          .then(resp => {
            this.$refs.lmlistv2.setDataPageAndComponentsProps()
            this.form = JSON.parse(this.initialForm)
            this.$refs.superpowerReemplazante.remove()
            this.lmToastSuccessMessage(`Se registró una nueva licencia para '${this.$route.params.id}'`, `Nueva Licencia`)
          })
          .finally(() => {
            this.$nextTick(() => { this.$v.form.$reset() })
            this.formIsProcessing = false
          })
      } catch (error) {
        console.log(error)
        this.formIsProcessing = false
      }
    },
    actualizarUsuarioAsignado (values) {
      const isThereValue = values.length
      const value = values[0]
      this.form.reemplazante = isThereValue ? value.id : ''
    }
  },
  watch: {
    'form.fechaDesde': function () {
      if (!this.form.fechaDesde) {
        this.form.fechaHasta = null
      }
    }
  },
  created () {
    (async () => {
      const insertAttributes = {
        validate: true,
        id: this.$route.params.id
      }
      await this.updateItemDetail({
        path: this.newEndpointUri,
        data: insertAttributes
      })
        .catch(e => {
          this.isAllowed = false
        })
      const allLmSuperPowerSelectOptions = await this.getAllLmSuperPowerSelectOptions([
        {
          name: 'usuarios',
          obj: {
            path: 'usuarios/porsecretaria/',
            id: this.$route.params.id,
            total: 1000
          }
        }
      ])
      allLmSuperPowerSelectOptions.forEach(async element => {
        const e = await element
        this.lmSuperPowerSelects[e.name].selectOptions = e.data
      })
    })()
    this.isLoading = false
    this.initialForm = JSON.stringify(this.form)
  }
}
</script>
